import { Icon } from "@/components/common/icon/Icon";
import { useNetworkStore } from "@/modules/auth/store/network";
import { formatNumber } from "@/modules/auth/utils/format";
import WebApp from "@twa-dev/sdk";
import { useTranslation } from "react-i18next";

type MemberProps = {
  telegramUsername?: string | null;
  refCode: string;
  teamVolumeUsd?: number;
  name?: string;
  ownDeposit: number;
  referralVolumeUsd: number;
};

const Member = ({
  telegramUsername,
  refCode,
  name,
  ownDeposit,
  referralVolumeUsd,
}: MemberProps) => {
  const { t } = useTranslation();

  const { filter, updatePath } = useNetworkStore();

  const toDownTree = () => {
    if (filter) return;

    updatePath(refCode);
  };

  const openChat = () => {
    if (!telegramUsername) return;

    WebApp.openTelegramLink(
      `https://t.me/${telegramUsername.replace("@", "")}`
    );
  };

  return (
    <div className="flex items-center gap-4 px-4">
      <button onClick={toDownTree} className="contents">
        <div className="flex-1 flex flex-col items-start gap-0.5 py-3">
          <p
            className={`text-[1.0625rem] leading-[1.375rem] ${
              telegramUsername ? "text-text" : "text-subtitle-text"
            }`}
          >
            {telegramUsername
              ? `@${telegramUsername}`
              : name
              ? name
              : t("network-page.no_username")}
          </p>
          <p className="text-[0.9375rem] leading-[1.25rem] text-subtitle-text text-left">
            {t("network-page.own_deposit")}:${formatNumber(ownDeposit)}
          </p>
          <p className="text-[0.9375rem] leading-[1.25rem] text-subtitle-text text-left">
            {t("network-page.referral_turnover")}: $
            {formatNumber(referralVolumeUsd >= 0 ? referralVolumeUsd : 0)}
          </p>
        </div>
        <p className="text-[1.0625rem] leading-[1.375rem] text-text">
          {refCode}
        </p>
      </button>
      {telegramUsername ? (
        <button onClick={openChat}>
          <Icon type="chat" className="w-6 h-6 fill-link" />
        </button>
      ) : (
        <Icon type="chat" className="w-6 h-6 fill-secondary-hint" />
      )}
    </div>
  );
};

export default Member;
